import styled from 'styled-components'

const Input = styled('input')`
  &[type='file'] {
    display: none;
  }
`

export default Input
